import React from 'react';
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Space } from 'antd';
import { FaUser } from 'react-icons/fa';
import { CiLogin } from 'react-icons/ci';
import { IoMdHeart } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { CgProfile } from 'react-icons/cg';

const LoggedInUser = ({ name, handleLogout, isScrolled }) => {
    const navigate = useNavigate();
    const items = [

        {
            key: '0',
            label: (
                <p  >
                   My Profile
                </p>
            ),
            icon: <CgProfile />,
            onClick: () => {
                navigate('/profile');
            },
        },
        {
            key: '1',
            label: (
                <p  >
                    Saved Properties
                </p>
            ),
            icon: <IoMdHeart />,
            onClick: () => {
                navigate('/saved-properties');
            },
        },
        {
            key: '2',
            label: (
                <p  >
                    Logout
                </p>
            ),
            icon: <CiLogin />,
            onClick: handleLogout
        },

    ];

    return <Dropdown
        menu={{
            items,
        }}

    >
        <a onClick={(e) => e.preventDefault()}>
            <Space>
                <Avatar style={{ backgroundColor: isScrolled ? '#022541' : '#ffff', color: !isScrolled ? '#022541' : '#ffff', cursor: 'pointer' }} size={35}>{name ? name.slice(0, 1) : <FaUser />}</Avatar>
            </Space>
        </a>
    </Dropdown>
};
export default LoggedInUser;